import {
  observableValue,
  useEffect,
  useSharableStates,
  view,
  WritableObservableValue,
} from '@esui/core';
import { HSTack, VSTack } from '@esui/core/layout/index.js';
import { DemoPage, Section } from '../@demo/utils.js';
import { Text } from '../text/index.js';
import { range } from '../util/range.js';
import { Select, SelectItem } from './index.js';

export const [SelectDemo] = view('esui-material-select-demo', {
  template() {
    const items: SelectItem<number>[] = [
      {
        name: 'Option 1',
        value: 1,
      },
      {
        name: 'Option 2',
        value: 2,
      },
      {
        name: 'Option 3',
        value: 3,
      },
    ];
    const [
      filledItem,
      outlinedItem,
      preselectedItem,
      iconItem,
      requiredItem,
      requiredOutlinedItem,
      disabledOptionItem,
    ] = useSharableStates(
      ...range(10).map(() => '')
    ) as WritableObservableValue<string>[];

    const [isRequiredItemValid, isRequiredOutlinedItemValid] =
      useSharableStates(false, false);

    useEffect(() => {
      preselectedItem.value = '2';
    }, []);

    return DemoPage(
      Section(
        'Filled',
        VSTack(
          Select('filled', filledItem).items(items),
          HSTack(Text('Value:'), Text(filledItem.value))
        )
      ),
      Section(
        'Outlined',
        VSTack(
          Select('outlined', outlinedItem).items(items),
          HSTack(Text('Value:'), Text(outlinedItem.value))
        )
      ),
      Section(
        'Preselected',
        VSTack(
          Select('preselected', preselectedItem).items(items),
          HSTack(Text('Value:'), Text(preselectedItem.value))
        )
      ),
      Section(
        'Icon',
        VSTack(
          Select('has icon', iconItem).items(items).icon('event'),
          HSTack(Text('Value:'), Text(iconItem.value))
        )
      ),
      Section(
        'Required',
        VSTack(
          Select('required filled', requiredItem)
            .items(items)
            .required()
            .isValid(isRequiredItemValid),
          HSTack(Text('Value:'), Text(requiredItem.value)),
          HSTack(Text('Valid:'), Text(`${isRequiredItemValid.value}`))
        )
      ),
      Section(
        'Required Outlined',
        VSTack(
          Select('required outlined', requiredOutlinedItem)
            .outlined()
            .required()
            .items(items)
            .isValid(isRequiredOutlinedItemValid),
          HSTack(Text('Value:'), Text(requiredOutlinedItem.value)),
          HSTack(Text('Valid:'), Text(`${isRequiredOutlinedItemValid.value}`))
        )
      ),
      Section(
        'Disabled',
        VSTack(Select('disabled', observableValue('')).disabled().items(items))
      ),
      Section(
        'Disabled Option',
        VSTack(
          Select('disabled option', disabledOptionItem).items(
            items.map(item => ({
              ...item,
              disabled: item.value === 2,
            }))
          ),
          HSTack(Text('Value:'), Text(disabledOptionItem.value))
        )
      ),
      Section(
        'Natural Menu Width',
        VSTack(
          Select('natural width (long)', observableValue(''))
            .items(
              items.map(item => ({
                ...item,
                name: 'Some Really Really Really long text',
              }))
            )
            .naturalMenuWidth(),
          Select('natural width (short)', observableValue(''))
            .items(
              items.map(item => ({
                ...item,
                name: 'Short text',
              }))
            )
            .naturalMenuWidth()
        )
      ),
      Section(
        'Full width',
        VSTack(
          Select('fullwidth', observableValue('')).items(items)
        ).templateColumns('90vw')
      )
    );
  },
});
